var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container",on:{"mouseover":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[_vm._t("default"),(_vm.show)?_c('div',{ref:"tooltip",staticClass:"tooltip-content",class:_vm.positionClass},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }